module.exports = __webpack_public_path__ + "img/asettings.ba4d6ee6.png";